import classNames from 'clsx';
import React, { type ReactElement, useMemo } from 'react';
import { SHARING_VARIANT } from 'reactApp/components/SharingWindow/blocks/Weblink/WeblinkList/SharingNewWeblinkList.types';

import styles from './User.css';
import { useAccessRights } from './User.hooks';
import type { UserInfoProps } from './User.types';

export const User = React.memo(function User(props: UserInfoProps): ReactElement | null {
    const {
        user,
        isOwner = false,
        item,
        isMounted,
        currentUserEmail,
        onClose,
        publicId,
        isPhone,
        variant = SHARING_VARIANT.default,
        isCompact,
    } = props;

    const userBlock = useAccessRights({ user, item, isMounted, onClose, isPhone, isOwner, publicId, variant });

    const userName = user?.name || (isOwner && 'Вы');

    const userAnnotation = useMemo(() => {
        if (user?.email === currentUserEmail) {
            return 'вы';
        } else if (isOwner) {
            return 'владелец';
        }

        return null;
    }, [isOwner, user?.email, currentUserEmail]);

    if (!user || (isMounted && user.email !== currentUserEmail)) {
        return null;
    }

    if (variant === SHARING_VARIANT.folders || variant === SHARING_VARIANT.foldersBiz) {
        return (
            <div
                className={classNames(styles.root, styles.root_tab, {
                    [styles[`root_status_${user.status}`]]: Boolean(user.status),
                    [styles.root_phone]: isPhone,
                    [styles.root_withDropdown]: !isOwner,
                })}
                data-qa-email={user.email}
                data-qa-status={user.status}
            >
                <div style={{ backgroundImage: `url(${user.avatarUrl})` }} className={styles.avatar} />
                <div className={styles.userContainer}>
                    <div className={styles.info}>
                        {userName && <div className={classNames(styles.name, { [styles.name_compact]: isCompact })}>{userName}</div>}
                        <div className={styles.email}>
                            {user.email}
                            {userAnnotation && <span className={styles.annotation}> ({userAnnotation})</span>}
                        </div>
                    </div>
                    {!isOwner && userBlock}
                </div>
            </div>
        );
    }

    return (
        <div
            className={classNames(styles.root, {
                [styles[`root_status_${user.status}`]]: Boolean(user.status),
                [styles.root_phone]: isPhone,
                [styles.root_withDropdown]: !isOwner,
            })}
            data-qa-email={user.email}
            data-qa-status={user.status}
        >
            <div style={{ backgroundImage: `url(${user.avatarUrl})` }} className={styles.avatar} />
            <div className={styles.userContainer}>
                <div className={styles.info}>
                    {user.name && <div className={styles.name}>{user.name}</div>}
                    <div className={styles.email}>{user.email}</div>
                </div>
                {userBlock}
            </div>
        </div>
    );
});
